var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackIcon = function SvgBackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.167 1.834a.8.8 0 0 1 1.132 1.131L3.797 7.466h10.336a.8.8 0 0 1 0 1.6H3.936l4.335 3.942a.8.8 0 0 1 .106 1.067l-.052.063a.8.8 0 0 1-1.13.054L1.328 8.859A.8.8 0 0 1 1.301 7.7z"
  })));
};
export default SvgBackIcon;